import React from 'react';

import { Route, Switch } from 'react-router';

import GuestPortal from 'components/Pages/GuestPortal';
import { GP_LANDING_ROUTE } from 'components/Pages/GuestPortal/Routes/constants';
import ErrorScreen from 'components/shared/ErrorScreen';

import Itinerary from '../ClientPortal/Itinerary';

export const PreviewRoutes = () => {
  return (
    <Switch>
      {/*@ts-ignore*/}
      <Route path={'/:handle/:id(\\d+)'} component={Itinerary} exact />
      <Route path={GP_LANDING_ROUTE} component={() => <GuestPortal />} exact />

      <Route>
        <ErrorScreen status="404" />
      </Route>
    </Switch>
  );
};

export default PreviewRoutes;
